<!--
 * @Author: your name
 * @Date: 2021-09-02 17:38:42
 * @LastEditTime: 2021-11-17 11:00:44
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ark-student-wap/src/pages/combinationCourse/combinationCourse.vue
-->
<template>
  <div class="combination course-detail-page" id="yd-page5">
    <!-- 主图 -->
    <CourseMain />
    <activityPrice />
    <!-- 标题 -->
    <CourseName />
    <!-- 价格 -->
    <!-- 课程标签  -->
    <courseTag />
    <CoursePrice v-show="allAcvitity.activeType === 0" />
    <DiscountZone
      :buyStatus="buyStatus"
      ref="discount"
      :giftCouponRespList="giftCouponRespList"
      :giftMaterialList="giftMaterialList"
      :giftMemberList="giftMemberList"
    />
    <!-- tab -->
    <div ref="tabOutside"></div>
    <SpringFestival />
    <div class="course-tab">
      <CourseTabs :tabFixed="tabFixed" />
    </div>
    <BuyFoot
      @tobuy="receiveBuy"
      :buyBtnData="buyBtnData"
      :buyStatus="buyStatus"
      @toShopCar="addShoppingCar"
      :cartCount="cartCount"
      @getDeatil="getDeatil"
    />
    <SelectCourse v-if="show" :buyBtnData="buyBtnData" @close="close" />
    <CarSelectCourse v-if="carShow" :buyBtnData="buyBtnData" @close="close" />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import {
  setTokenFromCookie,
  gioPlatform,
  getRegisterSourceInfo,
  replaceHyphens,
  isOnloadMantisChat,
  beforePageName,
  deleteMantisChat,
  beforePageNameMap,
} from '@/utils/tools';
import wx from 'weixin-js-sdk';
import { reqReceiveCoupon } from '@/api/coupon/index';
import SpringFestival from '@/components/springFestival/index.vue';
import { reqCombinationDetail, reqCombinationBuy, reqPackageGift } from '@/api/combination';
import { reqPrice } from '@/api/pay';
import {
  reqAddCart,
  reqCartCount,
  reqPackageName,
} from '@/api/courseDetail/shoppingCar/shoppingCar';
import { reqClassType, reqClassNameType } from '@/api/courseDetail';

import CourseName from './components/courseName.vue';
import CourseMain from './components/courseMain.vue';
import CoursePrice from './components/coursePrice.vue';
import CourseTabs from './components/courseTabs.vue';
import BuyFoot from './components/buyFoot.vue';
import activityPrice from './combinnationActivity/activityPrice.vue';
import SelectCourse from './components/selectCourse.vue';
import DiscountZone from './components/discountZone.vue';
import CarSelectCourse from './components/carSelectCourse.vue';
import courseTag from './components/courseTag.vue';

export default {
  components: {
    courseTag,
    CourseName,
    CourseMain,
    CoursePrice,
    CourseTabs,
    BuyFoot,
    activityPrice,
    SelectCourse,
    DiscountZone,
    SpringFestival,
    CarSelectCourse,
  },
  data() {
    return {
      scrollTopIt: 0, //
      show: false, // 是否展示选择课程弹窗
      // actionType: 0, // 登录后需要触发的动作
      buyStatus: false, // 购买状态
      combinationDeatil: {}, // 组合套餐详情
      carShow: false, // 加入购物车时选择课程弹窗
      cartCount: 0, // 购物车数量
      giftCouponRespList: null, // 赠送优惠券list
      giftMaterialList: null, // 赠送实物list
      giftMemberList: null,
      currentTime: new Date().getTime(),
    };
  },
  computed: {
    ...mapState(['userInfo', 'allAcvitity']),
    buyBtnData() {
      // status 0 不可购买  1 可购买
      let data = {};
      if (!this.combinationDeatil.coverMobile) return data;
      const { activeType, nowAcvitity } = this.allAcvitity;
      const { status, sellPrice } = this.combinationDeatil;
      if (status <= 4) {
        data = {
          btnTxt: '未上架',
          state: 1,
          status: 0,
        };
      } else if (this.buyStatus) {
        data = {
          btnTxt: '去学习',
          state: 2,
          status: 1,
        };
      } else if (status === 6) {
        data = {
          btnTxt: '已下架',
          state: 3,
          status: 0,
        };
      } else if (
        (activeType === 2 && nowAcvitity.state === 1) ||
        (activeType === 3 && nowAcvitity.state === 1)
      ) {
        data = {
          btnTxt: '立即秒杀',
          state: 4,
          status: 1,
        };
      } else if (activeType === 1 && nowAcvitity.state === 1) {
        data = {
          btnTxt: '立即抢购',
          state: 5,
          status: 1,
        };
      } else if (activeType === 4) {
        data = {
          btnTxt: '领券购买',
          state: 6,
          status: 1,
        };
      } else {
        data = {
          btnTxt: '立即购买',
          state: 7,
          status: 1,
        };
      }
      if (
        this.$root.miniprogram &&
        !this.$root.miniprogramBuyCourse &&
        data.state > 3 &&
        sellPrice
      ) {
        data = {
          bgColor: 'canBuy',
          btnTxt: '了解更多',
          state: 11,
          status: 1,
        };
      }
      return data;
    },
    tabFixed() {
      let itFixed = false;
      itFixed = this.scrollTopIt > this.$refs.tabOutside?.offsetTop;
      return itFixed;
    },
  },
  watch: {
    userInfo(data) {
      if (data.id) {
        // 登录后请求是否购买
        this.getBuyCourse();
        this.getCartNum(); // 查询购物车数量
      }
    },
    $route: {
      handler() {
        this.$router.go();
      },
      deep: true,
    },
  },
  mounted() {
    this.getDeatil();
    this.scrollInit();

    // 分享按钮
    window['iqhApp2jsBridge.triggerSC'] = {};
    window['iqhApp2jsBridge.triggerSC'].shareCourseJS = this.shareCourseJS;
    this.$sendToApp('hiddenShareButton', { showShare: 1 }, false);
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
    // eslint-disable-next-line no-unused-expressions
    this.userInfo.id && this.getCartNum();
  },
  destroyed() {
    deleteMantisChat();
    this.$store.dispatch('saveAllAcvitity', {});
    this.$store.dispatch('savCourseData', {});
    // 清除public/index.hmtl中前端控制螳螂自动触发的定时器
    // clearTimeout(timesCustomer);
  },
  methods: {
    async getLoginAfter() {
      await this.$root.getUserInfo();
      this.getDeatil();
    },
    getLogin(APPSESSION) {
      const cookieToken = APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        // alert('设置APPSESSION');
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    // 展示客服弹窗
    showMantisChatBox(data) {
      isOnloadMantisChat(this.userInfo, data);
    },
    // 请求套餐详情
    async getDeatil() {
      const { combinationId } = this.$route.query;
      const { code, data, msg, currentTime } = await reqCombinationDetail(combinationId);
      if (code === 0) {
        this.currentTime = currentTime
          ? new Date(replaceHyphens(currentTime)).getTime()
          : new Date().getTime();

        this.combinationDeatil = data;
        document.title = data.name;
        this.showMantisChatBox(data);
        this.getBuyCourse();
        this.canBuy(data);
        this.gioDetail();
        this.getCouponGiftList();
        this.miniBuy(data);
      } else {
        this.$toast(msg);
      }
    },
    miniBuy(combination) {
      combination.packageAttributeVOList.forEach(element => {
        if (element.valueType === 1 && this.$root.miniprogram) {
          reqClassType().then(data => {
            const status = data?.data.find(ele => ele.value === element.dataJson);
            this.$root.setMiniProgramBuy(status);
          });
        }
      });
    },
    canBuy(data) {
      const { packageProductRespList, packageGroupWebRespList } = data;
      let flag = true;
      (packageGroupWebRespList || []).forEach(element => {
        const filterRes = element.packageProductWebRespList.filter(course => {
          const { isBuy, isExpire, isSoldOut, isOffline } = course;
          return isBuy || isExpire || isSoldOut || isOffline;
        });
        if (element.groupProductNum - filterRes.length < element.selectProductNum) {
          flag = false;
        }
      });
      // 产品区域是否有购买 ---展示文案
      const buyState = (packageProductRespList || []).find(course => course.isBuy);
      // 产品区域是否有购买，下架，过期等 --- 按钮置灰
      const isDisabled = (packageProductRespList || []).find(course => {
        const { isBuy, isExpire, isSoldOut, isOffline } = course;
        return isBuy || isExpire || isSoldOut || isOffline;
      });
      const unaleBuy = isDisabled ? true : !flag;
      Object.assign(data, { isBuy: !!buyState, unaleBuy });
      this.$store.dispatch('savCourseData', { introductionType: 1, ...data });
    },
    // 请求套餐是否购买购买
    async getBuyCourse() {
      const { combinationId } = this.$route.query;
      const { code, data } = await reqCombinationBuy(combinationId);
      if (code === 0) {
        this.buyStatus = data;
      }
    },
    // 接受点击的购买动作
    receiveBuy() {
      if (this.buyBtnData.state === 11) {
        const url =
          'https://chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=67653fd704b13300018ae145';
        if (this.$root.$data.isApp) {
          this.$sendToApp(
            'openNewWebView',
            {
              url,
            },
            false,
          );
          return;
        }
        if (this.$root.miniprogram) {
          wx.miniProgram.navigateTo({
            url: `/subPackages/mantisChat/mantisChat?chatPageUrl=${encodeURIComponent(
              'https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=67653ff19d78140001e5277e',
            )}&probeId=67653ff19d78140001e5277e`,
          });
          return;
        }
        window.open(url);
        return;
      }
      // 校验登陆
      if (!this.checkLogin()) return;
      // 领券
      if (this.allAcvitity.activeType === 4) this.receiveCoupon();
      // 主产品是否全部为单品
      if (this.allSingleProduct()) {
        this.jumpPayOrder();
        return;
      }
      this.show = true;
    },
    // 校验是否登录
    checkLogin() {
      if (!this.userInfo.id) {
        const { isApp = false } = this.$root.$data;
        if (isApp) {
          getRegisterSourceInfo(this, 'combinationCourse', 5, true);
        } else if (this.$root.whatEev === 'miniprogram') {
          //const miniBeforePageName = localStorage.getItem('miniBeforePageName');
          // const { fullPath } = this.$route;
          // let pageUrl = null;
          // let miniPageUrl = '';
          // if (fullPath.indexOf('THIRD_SESSION') > 0) {
          //   pageUrl = fullPath.substring(0, fullPath.indexOf('THIRD_SESSION') - 1);
          // } else {
          //   pageUrl = fullPath;
          // }
          // if (miniBeforePageName) {
          //   miniPageUrl = `${pageUrl}&miniBeforePageName=${miniBeforePageName}`;
          // } else {
          //   miniPageUrl = pageUrl;
          // }
          // wx.miniProgram.redirectTo({
          //   url: `/subPackages/loginPage/loginPage?minipQuery=${encodeURIComponent(miniPageUrl)}`,
          // });
          let url = window.location.href;
          const [domain, searchParams] = url.split('?');
          if (searchParams) {
            const params = searchParams.split('&');
            const paramsMap = new Map();
            params.forEach(item => {
              const [key, value] = item.split('=');
              //  console.log('key', key, value);
              if (key) {
                paramsMap.set(key, value);
              }
            });
            const entries = paramsMap.entries();
            let query = '';
            const ExcludequeryArr = ['THIRD_SESSION', 'env'];
            for (const [key, value] of entries) {
              if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
            }
            url = `${domain}?${query}`;
            const redirctUrl = encodeURIComponent(
              `/subPackages/customShareWebview/webView?url=${encodeURIComponent(url)}`,
            );
            const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
            wx.miniProgram.redirectTo({
              url: path,
            });
          }
          return;
        } else {
          const param = { redirect: '/combinationCourse', ...this.$route.query };
          this.$router.push({ path: '/registrationLogin', query: param });
        }
        return false;
      }
      return true;
    },
    // 产品区域若全是单品 则直接进入下单页
    allSingleProduct() {
      const { packageProductRespList, packageGroupWebRespList } = this.combinationDeatil;
      if (packageGroupWebRespList) return false;
      const res = (packageProductRespList || []).every(item => {
        const { packageProductSkuWebRespList } = item;
        return (
          packageProductSkuWebRespList.length === 1 &&
          packageProductSkuWebRespList[0].isDefault === 1
        );
      });
      return res;
    },
    // 订单
    jumpPayOrder() {
      this.$sendToApp('hiddenShareButton', { showShare: 0 }, false);
      const { packageProductRespList, packageId } = this.combinationDeatil;
      const query = packageProductRespList.map(product => ({
        productId: product.productId,
        skuId: product.packageProductSkuWebRespList[0].skuId,
        packageId,
      }));
      const { liveRoomId } = this.$route.query;
      this.$router.push({
        path: '/payOrder',
        query: {
          product: JSON.stringify(query),
          packageId,
          liveRoomId,
        },
      });
      this.gioDefault(query, packageId);
    },
    async receiveCoupon() {
      const { couponId, couponVersion, couponChooseRespList } = this.allAcvitity.nowAcvitity;
      const coupon = couponChooseRespList.find(item => item.couponId === couponId);
      if (coupon.hasGetAlready) return;
      const res = await reqReceiveCoupon({
        couponId: String(couponId),
        couponVersion: Number(couponVersion),
        isLink: 0,
        fitPlatform: 1,
        fitEndPoint: this.$root.$data.isApp ? 2 : 4,
        terminalMark: this.$global.terminalMark,
      });
      if (res.code === 0) {
        this.$toast('领取成功');
      } else {
        this.$toast(res.msg);
      }
    },
    close() {
      this.show = false;
      this.carShow = false;
    },
    scrollInit() {
      const pageDiv = document.getElementsByClassName('course-detail-page')[0];
      const fun = () => {
        this.scrollTopIt = pageDiv.scrollTop; // 要做兼容 在模
      };
      pageDiv.addEventListener('scroll', fun, false);
    },
    // header 分享按钮（原生交互）
    shareCourseJS() {
      const query = {
        url: window.location.href,
        title: this.combinationDeatil.name,
        content: '',
        icon: '',
      };
      this.$sendToApp('share', query, false);
    },
    // 加入购物车按钮
    addShoppingCar() {
      // 主产品是否全部为单品直接加入购物车
      if (this.allSingleProduct()) {
        const { packageProductRespList, packageId } = this.combinationDeatil;
        const query = packageProductRespList.map(product => ({
          productId: product.productId,
          itemType: 1,
          skuId: product.packageProductSkuWebRespList[0].skuId,
        }));
        this.checkAddShopCar(query, packageId);
        return;
      }
      this.carShow = true;
    },
    // 加入购物车
    async checkAddShopCar(query, packageId) {
      // 关闭选课弹窗
      const data = {
        cartPackageItemList: query,
        packageId,
        type: 2, // 类型 1 产品 2 套餐
      };

      const res = await reqAddCart(data);
      if (res.code === 0) {
        this.$toast('已加入购物车');
        this.gioAddCart();
        this.getCartNum();
      } else {
        this.$toast(res.msg);
      }
    },
    // 获取购物车数量
    async getCartNum() {
      const res = await reqCartCount();
      if (res?.code === 0) {
        this.cartCount = res?.data;
      }
    },
    // 获取赠送优惠券/实物列表
    async getCouponGiftList() {
      const { combinationId } = this.$route.query;
      const res = await reqPackageGift(combinationId);
      if (res.code === 0 && res?.data) {
        const { giftCouponRespList, giftMaterialRespList, giftMemberRespList } = res?.data;
        // 优惠券
        this.giftCouponRespList = giftCouponRespList.length > 0 ? giftCouponRespList : null;
        // 实物
        this.giftMaterialList = giftMaterialRespList.length > 0 ? giftMaterialRespList : null;
        console.log(this.userInfo);
        // 会员
        if (!this.userInfo || (this.userInfo.level !== 20 && this.userInfo.level !== 30)) {
          // this.giftMemberList = giftMemberRespList.length > 0 ? giftMemberRespList : null;
          const { giftPackageId, memberLevel } = giftMemberRespList[0] || {};
          if (this.userInfo?.level >= 40 && memberLevel >= 40) {
            this.giftMemberList = null;
          } else {
            reqPackageName([giftPackageId]).then(res2 => {
              this.giftMemberList = [{ ...giftMemberRespList[0], name: res2.data[0].name }];
            });
          }
        }
      }
    },

    async gioDefault(query, packageId) {
      const res = await reqPrice({
        promotionBasicPrice: {
          endPoint: this.$root.$data.isApp ? 2 : 3,
          platform: 1,
        },

        promotionProductPackageReqList: [
          {
            packageId: Number(packageId),
            packageProductSkuReqList: query,
          },
        ],
      });
      if (res.code === 0) {
        const courseIdList = [];
        const courseNameList = [];
        const allianceId = [];
        const allianceName = [];
        const fullReductionId = [];
        const fullReductionName = [];
        const secondsKillNameList = [];
        const {
          orderPayPrice,
          orderTotalPrice,
          productPackageCalculateResultRespList,
          fullDiscountPrice,
          unionDiscountPrice,
          unionCalculateResultRespList,
          promotionFullCalculateResultRespList,
          singleCalculateResultRespList,
        } = res.data;
        // 注：套餐与普通字段不同取productPackageCalculateResultRespList
        if (productPackageCalculateResultRespList) {
          productPackageCalculateResultRespList[0].packageDetailCalculateResultRespList.forEach(
            element => {
              courseIdList.push(element.productId);
              courseNameList.push(element.productName);
            },
          );
        }
        if (unionDiscountPrice) {
          unionCalculateResultRespList.forEach(element => {
            allianceId.push(element.promotionId);
            allianceName.push(element.promotionName);
          });
        }
        if (fullDiscountPrice) {
          promotionFullCalculateResultRespList.forEach(element => {
            fullReductionId.push(element.promotionId);
            fullReductionName.push(element.promotionName);
          });
        }
        if (singleCalculateResultRespList) {
          singleCalculateResultRespList.forEach(element => {
            if (element.promotionLabel === 2 || element.promotionLabel === 3) {
              secondsKillNameList.push(element.promotionName);
            }
          });
        }
        // 立即购买埋点
        // eslint-disable-next-line
        const miniBeforePageName = window.localStorage.getItem('miniBeforePageName');
        const beforePage = miniBeforePageName || this.$route.query.beforePageName;
        gio('track', 'buyCourse_event', {
          courseIdList_var: courseIdList.toString(), // 课程 ID 列表
          courseNameList_var: courseNameList.toString(), // 课程名称列表
          courseTotalPrice_var: secondsKillNameList.length > 0 ? orderPayPrice : orderTotalPrice, // 课程总价
          isAlliance_var: unionDiscountPrice ? '是' : '否', // 是否参加联报
          allianceId_var: unionDiscountPrice ? allianceId.toString() : null, // 联报活动ID
          allianceName_var: unionDiscountPrice ? allianceName.toString() : null, // 联报活动名称
          allianceDiscountAmount_var: unionDiscountPrice || null, // 联报优惠金额
          isSecondsKill_var: secondsKillNameList.length > 0 ? '是' : '否', // 是否参加秒杀
          secondsKillNameList_var:
            secondsKillNameList.length > 0 ? secondsKillNameList.toString() : null, // 秒杀活动名称列表
          isFullReduction_var: fullDiscountPrice ? '是' : '否', // 是否参加满减
          fullReductionId_var: fullDiscountPrice ? fullReductionId.toString() : null, // 满减活动ID
          fullReductionName_var: fullDiscountPrice ? fullReductionName.toString() : null, // 满减活动名称
          fullReductionAmount_var: fullDiscountPrice || null, // 满减优惠金额
          platform_var: gioPlatform(),
          beforePageName_var: beforePageNameMap(beforePage),
        });
      }
    },
    gioDetail() {
      const { packageId, name, sellPrice } = this.combinationDeatil;
      const miniBeforePageName = window.localStorage.getItem('miniBeforePageName');
      const beforePage = miniBeforePageName || this.$route.query.beforePageName;
      const sceneMap = JSON.parse(localStorage.getItem('sceneMap') || '{}');
      console.log(sceneMap, 8899);
      // eslint-disable-next-line
      gio('track', 'courseDetailPage_event', {
        courseId_var: packageId.toString(),
        courseName_var: name,
        courseCate_var: null,
        courseSubject_var: null,
        coursePrice_var: sellPrice,
        isLogin_var: Boolean(this.userInfo.id).toString(),
        classSize_var: '',
        beforePageName_var: beforePageName(beforePage),
        platform_var: gioPlatform(),
        entryMode_var: sceneMap?.name,
        Usersource_var: sceneMap?.source,
        affiliatedTeacher_var: sceneMap?.teacher,
      });
    },
    // 加入购物车埋点
    gioAddCart() {
      const { packageId, name, sellPrice } = this.combinationDeatil;
      // eslint-disable-next-line
      gio('track', 'addtoCart_event', {
        comboId_var: packageId.toString(),
        comboName_var: name,
        comboPrice_var: sellPrice,
        platform_var: gioPlatform(),
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.combination {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  background: #f9f9f9;
}

.course-tab {
  border-top: 18px solid #f9f9f9;
}

::v-deep .springFestival {
  margin: 22px 0 0 0;
}
</style>
